// extracted by mini-css-extract-plugin
module.exports = {"carousel":"image-carousel_carousel__R7R1N","left":"image-carousel_left__Vlpa0","right":"image-carousel_right___VARJ","forward":"image-carousel_forward__NnFh7"};